import { Status } from '@webapp/ui';
import {
  IQuote,
  IQuoteRow,
  IQuoteWithInsurable,
  QuoteStatus,
} from '../interfaces/quotes.interface';

export function getBadgeAndActions(quote: IQuote | IQuoteWithInsurable): {
  badgeStatus: Status;
  action: string;
  badgeText: string;
} {

  if (quote.status === QuoteStatus.AcceptedInspection) {
    return {
      badgeStatus: Status.Success,
      action: 'Ver',
      badgeText: 'Inspección aceptada',
    };
  }
  if (quote.status === QuoteStatus.RejectedInspection) {
    return {
      badgeStatus: Status.Error,
      action: 'Ver',
      badgeText: 'Inspección rechazada',
    };
  }
  if (quote.status === QuoteStatus.expired) {
    return {
      badgeStatus: Status.Info,
      action: 'Ver',
      badgeText: 'Vencida',
    };
  }
  if (quote.status === QuoteStatus.onInspection) {
    return {
      badgeStatus: Status.Info,
      action: 'Ver',
      badgeText: 'En inspección',
    };
  }
  if (quote.status === QuoteStatus.InProgress) {
    return {
      badgeStatus: Status.Info,
      action: 'Ver',
      badgeText: 'Pendiente',
    };
  }
  if (quote.status === QuoteStatus.PendingInspection) {
    return {
      badgeStatus: Status.Info,
      action: 'Ver',
      badgeText: 'Inspección pendiente',
    };
  }
  return {
    badgeStatus: Status.Success,
    action: 'Ver',
    badgeText: 'Contratada',
  };
}

export function isExpired(quote: IQuote | IQuoteWithInsurable): boolean {
  return new Date() > quote.expiresAt;
}

export function mapQuotes(quote: IQuote[]): IQuoteRow[] {
  return quote.map((q) => ({
    ...q,
    ...getBadgeAndActions(q),
  }));
}
